@for (option of props.radioOptions ?? []; track option.value) {
  <div class="form-check mb-2">
    <input
      type="radio"
      class="form-check-input {{ props.cssClass }}"
      [id]="optionId(option)"
      [name]="props.name"
      [value]="option.value"
      [formControl]="$any(formControl)"
      [attr.disabled]="option.disabled ? true : null"
      [class.is-invalid]="hasValidation && invalid"
    />
    <label class="form-check-label" [class.text-muted]="option.disabled" [for]="optionId(option)">
      <span class="fw-semibold">{{ option.label }}</span>
      @if (option.description) {
        <span class="d-block small">{{ option.description }}</span>
      }
    </label>
  </div>
}
